var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"ck-row row-editor"},[_c('div',{staticClass:"editor-container"},[_c('div',{ref:"editor",staticClass:"editor",domProps:{"innerHTML":_vm._s(_vm.html)}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ck-row"},[_c('div',{staticClass:"document-editor__toolbar"})])
}]

export { render, staticRenderFns }